import { createFeatureSelector } from '@ngrx/store'
import { ILpisDatasourceState} from './lpis-datasource.reducer'
import { StoreKeysEnum } from '../../../../store/store-keys'

export const selectLpisDatasourceFeature = createFeatureSelector<Readonly<ILpisDatasourceState>>(StoreKeysEnum.LpisDatasource)
